import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import useAppContext from '../../contexts/UseAppContext';
import ImageWrapper from '../ImageWrapper/ImageWrapper';
import VersionTag from '../VersionTag/VersionTag';
import Activity from '../../helpers/Activity';
import ExternalAnalytics from '../../helpers/ExternalAnalytics';
import Viewport from '../../helpers/Viewport';
import Navigation from '../../config/Navigation';
import clientLogo from './images/logo.svg';
import scanIcon from './images/scan.svg';
import payIcon from './images/pay.svg';
import pickupIcon from './images/pickup.svg';
import metadata from '../../../package.json';
import './NavigationBarV2.css';

function NavigationBarV2({section, showCartLink}) {
    const navigate = useNavigate();
    const context = useAppContext();
    const shoppingCart = context.shoppingCart;
    const smallModeThreshold = 400;
    const scannerLinkLabel = 'Carro';

    const inSmallMode = () => {
        const viewport = Viewport.dimensions;
        return viewport.width < smallModeThreshold;
    };

    const [isInSmallMode, setIsInSmallMode] = useState(inSmallMode());

    useEffect(() => {
        setResizeListener();
        return () => {
            removeResizeListener();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setResizeListener = () => {
        window.addEventListener('resize', handleResize);
    };

    const removeResizeListener = () => {
        window.removeEventListener('resize', handleResize);
    };

    const handleResize = () => {
        setIsInSmallMode(inSmallMode());
    };

    const getItemsCount = () => {
        const shoppingCart = context.shoppingCart;
        return shoppingCart && shoppingCart.items ? shoppingCart.getTotalQuantity() : 0;
    };

    const toCart = () => {
        if (showCartLink) {
            const source = shoppingCart && shoppingCart.hasItems() ? shoppingCart.items[0] : undefined;
            ExternalAnalytics.goTo(source, section, 'link', scannerLinkLabel);
            Activity.log('navigation-bar', 'cart-link', 'click');
            const url = Navigation.getCartUrl();
            navigate(url);
        }
    };

    const navigationBarStyle = () => {
        return {
            height: context.navigationBarHeight
        };
    };

    const centralContainerStyle = () => {
        return {
            width: isInSmallMode ? '67%' : '34%'
        };
    };

    const logoContainerStyle = () => {
        return {
            justifyContent: isInSmallMode ? 'flex-start' : 'center',
            alignItems: isInSmallMode ? 'center' : 'flex-start',
            top: isInSmallMode ? '50%' : 'unset',
            left: isInSmallMode ? '0' : 'unset',
            transform: isInSmallMode ? 'translateY(-50%)' : 'unset',
            margin: isInSmallMode ? '0px 10px' : '10px 5px 5px 5px'
        };
    };

    const versionTagStyle = () => {
        return {
            left: isInSmallMode ? 0 : '50%',
            transform: isInSmallMode ? 'unset' : 'translateX(-50%)'
        };
    };

    const itemsCountStyle = () => {
        return {
            fontSize: isInSmallMode ? 15 : 17
        };
    };

    return (
        <div className='navigation-bar' style={navigationBarStyle()}>
            {!isInSmallMode && (
                <div className='navigation-bar_container left'>
                </div>
            )}
            <div className='navigation-bar_container central' style={centralContainerStyle()}>
                <div className='navigation-bar_logo-container' style={logoContainerStyle()}>
                    <ImageWrapper
                        image={clientLogo}
                        alt='Compra QR'
                        display='block'
                        width={200}
                        height='auto'
                        errorWidth={undefined}
                        errorHeight={undefined}
                        errorPadding={undefined}
                        margin={0}
                        borderRadius={0}
                        transition={true}
                        loadDelay={0.1}
                        onLoad={undefined}
                        onMouseEnter={undefined}
                        onMouseLeave={undefined}
                    />
                    {context.showVersionTag && (
                        <div className='navigation-bar_version-tag' style={versionTagStyle()}>
                            <VersionTag color='#FFFFFF' version={metadata.version} throwErrorOnClick={context.throwExceptionOnVersionClick}/>
                        </div>
                    )}
                </div>
                {!isInSmallMode && (
                    <div className='navigation-bar_steps-container'>
                        <div className='navigation-bar_step'>
                            <div className='navigation-bar_step-icon-container'>
                                <ImageWrapper
                                    image={scanIcon}
                                    alt='Scan'
                                    display='block'
                                    width={15}
                                    height='auto'
                                    errorWidth={undefined}
                                    errorHeight={undefined}
                                    errorPadding={undefined}
                                    margin={2}
                                    borderRadius={0}
                                    transition={true}
                                    loadDelay={0.1}
                                    onLoad={undefined}
                                    onMouseEnter={undefined}
                                    onMouseLeave={undefined}
                                />
                            </div>
                            <div className='navigation-bar_step-label'>Escanea</div>
                        </div>
                        <div className='navigation-bar_step'>
                            <div className='navigation-bar_step-icon-container'>
                                <ImageWrapper
                                    image={payIcon}
                                    alt='Pay'
                                    display='block'
                                    width={15}
                                    height='auto'
                                    errorWidth={undefined}
                                    errorHeight={undefined}
                                    errorPadding={undefined}
                                    margin={2}
                                    borderRadius={0}
                                    transition={true}
                                    loadDelay={0.1}
                                    onLoad={undefined}
                                    onMouseEnter={undefined}
                                    onMouseLeave={undefined}
                                />
                            </div>
                            <div className='navigation-bar_step-label'>Paga</div>
                        </div>
                        <div className='navigation-bar_step'>
                            <div className='navigation-bar_step-icon-container'>
                                <ImageWrapper
                                    image={pickupIcon}
                                    alt='Pickup'
                                    display='block'
                                    width={15}
                                    height='auto'
                                    errorWidth={undefined}
                                    errorHeight={undefined}
                                    errorPadding={undefined}
                                    margin={2}
                                    borderRadius={0}
                                    transition={true}
                                    loadDelay={0.1}
                                    onLoad={undefined}
                                    onMouseEnter={undefined}
                                    onMouseLeave={undefined}
                                />
                            </div>
                            <div className='navigation-bar_step-label'>Retira</div>
                        </div>
                    </div>
                )}
            </div>
            <div className='navigation-bar_container right'>
                {showCartLink && (
                    <div className='navigation-bar_items-count' style={itemsCountStyle()} onClick={toCart}>
                        {scannerLinkLabel} ({getItemsCount()})
                    </div>
                )}
            </div>
        </div>
    );
}

export default NavigationBarV2;